import Vue from 'vue'
import Router from 'vue-router'

const pageMain = resolve => require(['./components/pages/main'], resolve);
const pageImpressum = resolve => require(['./components/pages/impressum'], resolve);
const pageDatenschutz = resolve => require(['./components/pages/datenschutz'], resolve);
const pageFeedback = resolve => require(['./components/pages/feedback'], resolve);
const pageEinstellungen = resolve => require(['./components/pages/einstellungen'], resolve);
const pageSteuersaetze = resolve => require(['./components/pages/steuersaetze'], resolve);
const NotFoundComponent = resolve => require(["./components/pages/notFound"], resolve);
const pageAnmelden = resolve => require(["./components/pages/anmelden"], resolve);
const pageApps = resolve => require(["./components/pages/apps"], resolve);

Vue.use(Router);

export default new Router({
    base: process.env.BASE_URL,
    /*mode: process.env.CORDOVA_PLATFORM ? "hash" : "history",*/
    mode: "history",
    routes: [
        {
            path: '/',
            alias: '/index.html',
            name: 'main',
            component: pageMain
        },
        {
            path: '/impressum',
            name: 'impressum',
            component: pageImpressum
        },
        {
            path: '/einstellungen',
            name: 'einstellungen',
            component: pageEinstellungen
        },
        {
            path: '/anmelden',
            name: 'anmelden',
            component: pageAnmelden
        },
        {
            path: '/apps',
            name: 'apps',
            component: pageApps
        },
        {
            path: '/datenschutz',
            name: 'datenschutz',
            component: pageDatenschutz
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: pageFeedback
        },
        {
            path: '/steuersaetze',
            name: 'steuersaetze',
            component: pageSteuersaetze
        },
        {   path: '*',
            component: NotFoundComponent
        }

  ]
})
